import { render } from "./ListKkp.vue?vue&type=template&id=76079f42&scoped=true"
import script from "./ListKkp.vue?vue&type=script&lang=js"
export * from "./ListKkp.vue?vue&type=script&lang=js"

import "./ListKkp.vue?vue&type=style&index=0&id=76079f42&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76079f42"]])

export default __exports__